<template>
  <v-container>
    <v-card color="transparent">
      <v-card-title
        class="secondary--text justify-center font-weight-bold headline"
      >
        {{ $t("pages.settings") }}
      </v-card-title>
      <v-card-text>
        <v-list color="transparent">
          <v-list-item v-for="(item, i) in settingsList" :key="i" class="my-2">
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.label }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <template v-if="item.type === 'checkbox'">
                <v-checkbox
                  @change="item.cb()"
                  v-model="item.value"
                ></v-checkbox>
              </template>
              <template v-else-if="item.type === 'button'">
                <v-icon @click="item.cb()">fa-trash</v-icon>
              </template>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- clear fav list modal -->
    <v-dialog v-model="clearFavListDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t("settings['remove_bookmarks']") }} ؟
        </v-card-title>
        <v-card-actions>
          <v-btn rounded color="primary" @click="clearFavListDialog = false">
            {{ $t("cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" rounded @click="clearFavFn()">
            {{ $t("agree") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "settings",
  data: () => ({
    settingsList: [],
    clearFavListDialog: false,
  }),
  created() {
    this.settingsList.push(
      {
        type: "checkbox",
        icon: "fa-moon",
        label: this.$t("settings['enable_dark_mode']"),
        value: this.$vuetify.theme.dark,
        cb: () => {
          const $this = this.settingsList.find((s) => s.icon === "fa-moon");
          this.switchTheme();
          $this.value = !$this.value;
        },
      },
      {
        type: "button",
        icon: "fa-bookmark",
        label: this.$t("settings['remove_bookmarks']"),
        value: false,
        cb: () => {
          this.clearFavListDialog = true;
        },
      }
    );
  },
  methods: {
    clearFavFn() {
      this.updateLocalStorage("favlist", []);
      this.$store.commit("emptyFav");
      this.clearFavListDialog = false;
    },
  },
  metaInfo: {
    title: "الاعدادات",
  },
};
</script>
